import React from 'react';

const AgoraBirdIcon = ({ className = "w-6 h-6" }) => {
  return (
    <img 
      src="/images/favico/agora.png" 
      alt="Ágora Bird" 
      className={`object-contain ${className}`} 
    />
  );
};

export default AgoraBirdIcon;
